export const usersHeaders = [
    {
      id: "link",
      name: "Nutzername",
    },
    {
        id: "role",
        name: "Rolle",
    },
]